import { type HTMLAttributes } from "react";
import { useInterruptCard } from "../InterruptCardContext";

/**
 * Renders `interrupt.description` as body prose. No-op if the producer
 * didn't set a description (the heading + actions can stand alone).
 */
export function Description(props: HTMLAttributes<HTMLParagraphElement>) {
  const { interrupt } = useInterruptCard();
  if (!interrupt.description) return null;
  return (
    <p
      {...props}
      className={["text-sm text-zinc-700 leading-relaxed", props.className]
        .filter(Boolean)
        .join(" ")}
    >
      {interrupt.description}
    </p>
  );
}
